module.exports = __webpack_public_path__ + "static/media/mnf-login.c462a874.png";